import { Box, BoxProps, Link, Stack, styled } from '@mui/material'

import { FC } from 'react'

import { AppConfigProvider } from '../../providers'

const StyledBox = styled(Box)<BoxProps>(({ theme }) => ({
  letterSpacing: '.1rem',
  [theme.breakpoints.down(420)]: {
    fontSize: 12,
    letterSpacing: 0,
  },
}))

export const AppAlert: FC = () => {
  return (
    <StyledBox>
      {!!AppConfigProvider.alertActive &&
        !!AppConfigProvider.alertText &&
        (AppConfigProvider.alertHref ? (
          <Stack
            component={Link}
            letterSpacing="inherit"
            href={AppConfigProvider.alertHref}
            alignItems="center"
            direction="row"
            justifyContent="center"
            width="100%"
            dangerouslySetInnerHTML={{ __html: AppConfigProvider.alertText }}
          ></Stack>
        ) : (
          <Stack
            alignItems="center"
            direction="row"
            justifyContent="center"
            width="100%"
            dangerouslySetInnerHTML={{ __html: AppConfigProvider.alertText }}
          ></Stack>
        ))}
    </StyledBox>
  )
}
AppAlert.displayName = 'AppAlert'
